		<template>
			<main class="main-wrapper flex-grow-1 bg-documentGray">
				<div class="d-flex align-items-center bg-white">
					<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
						{{$t('3212')}}
					</div>
					<div class="mgr-24 right-button">
					<button type="button" class="mdc-button mdc-dialog__button"
									data-mdc-dialog-action="discard" @click="goToSearch" @keypress="goToSearch" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-color-iconActive font-m">{{$t('3213')}}</span>
					</button>
					</div>
				</div>
				<div class="divider"></div>
		<!-- <div class="pdt-14 pdb-14 pdl-16 pdr-16 d-flex flex-row justify-content-between align-items-center" v-if="!isNoData">
			<div class="t-body3 t-color-bodyGrayA font-r t-line-h-20"> {{$t('3214', {str: totalGoodsCount})}}</div>
				<div class="pdt-11 pdb-10 pdl-16 pdr-16 position-relative p-0">
					<div class="d-flex align-items-center justify-content-end">
						<div class="t-body2 font-m t-color-bodyGrayA">{{menuTypeTitle}}</div>
						<div class="pdl-8 position-relative mdc-menu-anchor menu-container h-24"><i
								class="material-icons js--dropdown-toggle t-color-bodyGrayA" id="mdc-menu-anchor" @click="getDropDown($event)">arrow_drop_down</i>
							<div class="mdc-menu mdc-menu-surface toggle-menu toggle-menu_open">
								<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical"
									tabindex="-1">
									<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" @click="onSelect('EXPIRATION_IMMINENT','3215',$event)">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body3 font-r" :class="color">{{$t('3215')}}</span>
									</li>
									<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" @click="onSelect('LATEST_DELIVERY_DATE','3219',$event)">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body3 font-r t-color-bodyGrayA">{{$t('3219')}}</span>
									</li>
									<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" @click="onSelect('LATEST_CREATED','3220')">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body3 font-r t-color-bodyGrayA">{{$t('3220')}}</span>
									</li>
									<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" @click="onSelect('NAME_ASC','3221')">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body3 font-r t-color-bodyGrayA">{{$t('3221')}}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div> -->
					<div class="container container--narrow pdt-30  ">
					<div class="d-flex justify-content-between align-items-center" v-if="!isNoData">
						<div class="t-body3 t-color-bodyGrayA font-r t-line-h-20">{{$t('3214', {str: totalGoodsCount})}}</div>
						<div class="position-relative p-0">
							<div class="d-flex align-items-center justify-content-end">
								
								<div class="pdl-8 position-relative mdc-menu-anchor menu-container">
									<button type="button" class="mdc-button mdc-dialog__button js--dropdown-toggle" @click="getDropDown($event)" @keypress="getDropDown($event)" tabindex="0">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-color-primary font-r t-color-bodyGrayA">{{menuTypeTitle}}</span>
										<i class="material-icons t-color-bodyGrayA" id="mdc-menu-anchor" >arrow_drop_down</i>
									</button>
								   
									<div class="mdc-menu mdc-menu-surface toggle-menu edm-toggle" >
										<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical"
											tabindex="-1">
											<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" tabindex="0" @click="onSelect('EXPIRATION_IMMINENT','3215',$event)" @keypress="onSelect('EXPIRATION_IMMINENT','3215',$event)">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r t-color-headlineBlack">{{$t('3215')}}</span>
											</li>
											<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" tabindex="0" @click="onSelect('LATEST_DELIVERY_DATE','3219',$event)" @keypress="onSelect('LATEST_DELIVERY_DATE','3219',$event)">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r t-color-bodyGrayA">{{$t('3219')}}</span>
											</li>
											<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" tabindex="0" @click="onSelect('LATEST_CREATED','3220',$event)" @keypress="onSelect('LATEST_CREATED','3220',$event)">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r t-color-bodyGrayA">{{$t('3220')}}</span>
											</li>
											<li class="mdc-list-item min-h-48 d-flex align-items-center" role="menuitem" tabindex="0" @click="onSelect('NAME_ASC','3221',$event)" @keypress="onSelect('NAME_ASC','3221',$event)">
												<span class="mdc-list-item__ripple"></span>
												<span class="mdc-list-item__text t-body6 font-r t-color-bodyGrayA">{{$t('3221')}}</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="divider mgt-16" v-if="!isNoData"></div>
		<div>
			<div class="pda-default" v-if="isNoData" >
				<no-data :msgData="{msg1:'3222',msg2:'3223'}" v-if="isNoData" ></no-data>
			</div>
		<div class="pdt-16 pdb-26" v-if="!isNoData">
			<div class="mdc-card mgb-24 pda-24" v-for="(list,index) in listData" :key="index" tabindex="0" @click="viewDetail(list.id)" @keypress="viewDetail(list.id)">
				<div class="d-flex cursor-pointer">
					<div class="edm-list-icon pdr-20" v-if="list.image && list.image.resourceUri">
						<img :src="list.image.resourceUri" :alt="list.image.name" class="b-radius4">
					</div>
					<div class="flex-grow-1">
						<div class="d-flex align-items-start flex-grow-1 justify-content-between w-full">
							<div class="d-flex align-items-baseline">
								<div class="t-body3 font-r t-color-bodyGrayA t-line-h20 pdr-8">{{$t('3216')}}</div>
								<div class="t-subtitle5 font-m t-line-h-24">{{$moment(list.expirationDate).format('L')}}</div>
							</div>
							<div v-if="currentDate > $moment(list.expirationDate).format('YYYY.MM.DD')" class="pdl-7 pdr-7 t-body4 t-color-whiteHigh bg-contentRed b-radius4 d-flex justify-content-center align-items-center min-w-38 min-h-24">
								{{$t('3217')}}
							</div>
								<div v-else :class="getHowManyDaysLeft($moment(list.expirationDate).format('YYYY-MM-DD')) ? 't-body4 t-color-whiteHigh bg-iconInactive b-radius4 d-flex justify-content-center align-items-center min-w-38 min-h-24' : ''" >
									{{ getHowManyDaysLeft($moment(list.expirationDate).format('YYYY-MM-DD')) }}
								</div>
						</div>
						<div class="t-body3 t-line-h-22 t-color-bodyGrayA mgt-14 font-r">{{list.goods.hcategoryNames}}</div>
						<div class="t-body1 l-spacing48 t-line-h-26 font-r">{{list.goods.name}}</div>
					</div>
				</div>
			</div>
</div>
			<infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
				<div slot="no-more" class="pdt-10 pdb-16"> </div>
				<div slot="no-results" class="pdt-10 pdb-16"></div>
			</infinite-loading>
		</div>
		</div>
		<!-- {{listData}} -->
	</main>
</template>

<script>
/**
 * 단독 전체 시험 목록 메인 컴포넌트(independent total exam list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import {MDCMenu} from '@material/menu';
import storeApi from '@/api/storeMgtApi.js'
import NoData from '../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
	components: {
		NoData,
		InfiniteLoading
	},

	data() {
		return {
			isNoData: false,
			
			totalGoodsCount: 0,
			campaignData: null,
			menuTypeTitle:this.$t('3215'),
			color:'t-color-headlineBlack',
			currentDate: this.$moment(new Date()).format('YYYY.MM.DD'),
			selectedMenuType: 'EXPIRATION_IMMINENT',

			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			showDropIcon:false
		}
	},

	watch:{
		$route (to, from){
			this.initData()
		}
	},
	
	mounted() {
		
		if(document.querySelectorAll('.toggle-menu')){
			const menuEls = Array.from(document.querySelectorAll('.toggle-menu'));
			menuEls.forEach((menuEl) => {
				// Initialize MDCSimpleMenu on each ".mdc-simple-menu"
				const menu = new MDCMenu(menuEl);
				// We wrapped menu and toggle into containers for easier selecting the toggles
				const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
				dropdownToggle.addEventListener('click', () => {
					menu.open = !menu.open;
				});
			});
		}
	},

	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
		
		initData() {
			this.listData= []
			this.currentPage = 1
			this.totalPages = 1
			this.infiniteId += 1
		},

		// 목록 데이터 호출(get goods list data)
		fetchData($state) {
			let responseData = null
			let params = this.setParams()

			if (this.totalPages >= this.currentPage) {
				storeApi.goodsList(params).then((response) => {
					let responseData = response.data.data
					
					this.listData = this.listData.concat(responseData.content)
					this.currentPage++
					this.totalPages = responseData.totalPages
					this.totalGoodsCount = responseData.totalElements
					
					if (responseData.content.length) {
						$state.loaded()
					}else {
						$state.complete()
					}

					if (!this.listData.length) {
						this.isNoData = true
					}
				}).catch((err) => {
                    this.$hideLoading();
                    console.log(err.response)                        
                    responseData = err.response.data.meta
                    let errMsg = this.$t(`system.err.${responseData.errCode}`)
                    this.$error({content: errMsg}).then(() => {
                        this.$hideLoading();
                        this.$router.push('/home')
                    })
                })

			}else {
				$state.complete()
			}

		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				// storeId:'223',
				type: this.selectedMenuType,
				page: this.currentPage,
				size: 10,
				sort: 'id,desc'
			}
			return params
		},

		onSelect(type, lang,evt) {
			this.menuTypeTitle = this.$t(lang);
			this.selectedMenuType = type
			this.initData()
			document.getElementById("mdc-menu-anchor").click()
		},

		getExpirationDate(expDate){
			let today = new Date();
			let currentDate = this.$moment(today).format('YYYY.MM.DD');
			let expirationDate = this.$moment(expDate).format('YYYY.MM.DD');
			if(currentDate > expirationDate){
				return this.$t('3217')
			}
			// console.log('currentDate',currentDate)
			// console.log('expirationDate',expirationDate)
		},
		getHowManyDaysLeft(expDate){
			//console.log('expDate==>',expDate)
			//let expDates = expDate;
			//let expDates = Number(new Date('2021.08.18T20:00'));
			// let milliseconds = (new Date('2021-08-18')).getTime();
			// console.log('milliseconds=>Static==>',milliseconds)

			//let expDatesDynamic = Number(new Date(expDate));
			//let expirationDate = (new Date(expDate)).getTime();

			//console.log('milliseconds=>Dynamic==>',millisecondsDyan)
			let today = new Date();
			//console.log('today==>',today)
			let currDate = this.$moment(today).format('YYYY-MM-DD')
			let currentDate = this.$moment(currDate).valueOf();
			// console.log('currentDate==>',currentDate)
			let expirationDate = this.$moment(expDate).valueOf()
			//console.log('expirationDate==>',expirationDate)
			const ONE_DAY = 1000 * 60 * 60 * 24;
			// console.log('ONE_DAY==>',ONE_DAY)
			// Calculate the difference in milliseconds
			let differenceMs = Math.abs(currentDate - expirationDate);
			//console.log('differenceMs==>',differenceMs)
		   
			let days= Math.round(differenceMs / ONE_DAY);
			//console.log('days=>',days)
			if(days<8) {
				return 'D'+'-'+days 
			};
			
		},
		getDropDown(evt){
			
			setTimeout(function () {
			//	console.log(document.querySelector('#mdc-menu-anchor'), ' __evt.target')
				let closeSubmenu = evt.target.parentNode.nextElementSibling.className.split(/\s+/).find(val=>val=='mdc-menu-surface--open');
				if(closeSubmenu){
					document.querySelector('#mdc-menu-anchor').innerHTML = 'arrow_drop_up'
				} else {
					document.querySelector('#mdc-menu-anchor').innerHTML = 'arrow_drop_down'
				}
			}, 100);  
		},
		
		viewDetail(id){
			this.$router.push({
				name: 'StoreView',
				params: {goodsId: id},
			})
		},
			goToSearch() {
				this.$router.push({
					name: 'StoreProductCategory',
				})
			}
	}
}
</script>
<style scoped>
.pdA-7{
	padding:7px!important
}
.mdc-list-item{
	padding-left: 12px;
	padding-right: 12px;
}
</style>